import Lottie from 'lottie-react';
import logoAnimation from '../assets/logo-animation.json';

interface LogoAnimationProps {
  size?: number;
  loop?: boolean;
  className?: string;
}

// Fallback SVG 로고
function FallbackLogo({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 100 100" style={{ width: size, height: size }} fill="none">
      <rect x="17" y="15" width="16" height="70" fill="#BFFF00" rx="2"/>
      <rect x="67" y="15" width="16" height="70" fill="#00FFD1" rx="2"/>
      <rect x="17" y="15" width="66" height="14" fill="#66FF66" rx="2"/>
      <path d="M35 55 L45 67 L68 43" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default function LogoAnimation({ 
  size = 80, 
  loop = false,
  className = ''
}: LogoAnimationProps) {
  return (
    <div 
      className={className}
      style={{ width: size, height: size }}
    >
      {logoAnimation ? (
        <Lottie
          animationData={logoAnimation}
          loop={loop}
          autoplay={true}
          style={{ width: '100%', height: '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid slice'
          }}
        />
      ) : (
        <FallbackLogo size={size} />
      )}
    </div>
  );
}
